var Curriculog = Curriculog || {};

Curriculog.UserRoleFlyoutTitleView = (function ($, _, Backbone, UserRoleFlyoutTitleView) {

	UserRoleFlyoutTitleView = Curriculog.FlyoutTitleView.extend({
		template: 'HierarchyFlyout/flyoutTitle.html',

		initialize: function (options) {
			this.users = options.users;
			this.roles = options.roles;
			this.model = options.model;
      this.params = options.params;
			this.listenTo(this.model, 'change', this.render);
			this.render();
		},

		render: function () {
			userID = this.model.get('user_id');
			user = this.users.get(userID);
			sanitizedUserModel = user.getSanitizedModel();

			roleID = this.model.get('role_id');
			role = this.roles.get(roleID);
			sanitizedRoleModel = role.getSanitizedModel();

			this.title = sanitizedUserModel.name() + ' : ' + sanitizedRoleModel.get('name');
      var templateData = {
        title: this.title,
        cui_enabled: this.params.cui_enabled
      };
      var el = nunjucks.render(this.template, templateData);
      this.replaceElement(el);
		},
	});

	return UserRoleFlyoutTitleView;

})($, _, Backbone, Curriculog.UserRoleFlyoutTitleView || {});
